














































































































































































































































































































import * as pdfjsLib from 'pdfjs-dist/webpack'
// @ts-ignore
import * as pdfjsViewer from 'pdfjs-dist/web/pdf_viewer'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import globalMixin from '../globalMixin'


/* eslint @typescript-eslint/no-this-alias : 0 */
/* eslint consistent-this : 0 */

export default mixins(mobileTypeMixin, routeMixin, globalMixin).extend({
    data: () => {
        return {
            pdf: null as null | string,
        }
    },
    methods : {
        previous(){
            history.back()
        }
    },
    mounted() {

        const vueInstance = this;

        if (!this.$route.params.pdfUrl)
            return /* Copyright 2016 Mozilla Foundation
             *
             * Licensed under the Apache License, Version 2.0 (the "License");
             * you may not use this file except in compliance with the License.
             * You may obtain a copy of the License at
             *
             *     http://www.apache.org/licenses/LICENSE-2.0
             *
             * Unless required by applicable law or agreed to in writing, software
             * distributed under the License is distributed on an "AS IS" BASIS,
             * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
             * See the License for the specific language governing permissions and
             * limitations under the License.
             */
        ;('use strict')

        if (!pdfjsLib.getDocument || !pdfjsViewer.PDFViewer) {
            // eslint-disable-next-line no-alert
            alert('Please build the pdfjs-dist library using\n `gulp dist-install`')
        }

        const USE_ONLY_CSS_ZOOM = true
        const TEXT_LAYER_MODE = 0 // DISABLE
        const MAX_IMAGE_SIZE = 1024 * 1024
        const CMAP_URL = '../../node_modules/pdfjs-dist/cmaps/'
        const CMAP_PACKED = true

        const DEFAULT_URL = ''
        const DEFAULT_SCALE_DELTA = 1.1
        const MIN_SCALE = 0.25
        const MAX_SCALE = 10.0
        const DEFAULT_SCALE_VALUE = 'auto'

        const PDFViewerApplication = {
            pdfLoadingTask: null as null | any,
            pdfDocument: null as null | any,
            pdfViewer: null as null | any,
            pdfHistory: null as null | any,
            pdfLinkService: null as null | any,
            eventBus: null as null | any,
            url: null as null | any,
            documentInfo: null as null | any,
            metadata: null as null | any,
            l10n: pdfjsViewer.NullL10n,

            /**
             * Opens PDF document specified by URL.
             * @returns {Promise} - Returns the promise, which is resolved when document
             *                      is opened.
             */
            open(params: any) {
                if (this.pdfLoadingTask) {
                    // We need to destroy already opened document
                    return this.close().then(
                        function () {
                            // ... and repeat the open() call.
                            // @ts-ignore
                            return this.open(params)
                        }.bind(this)
                    )
                }

                const url = params.url
                // this.setTitleUsingUrl(url)

                // Loading document.
                const loadingTask = pdfjsLib.getDocument({
                    url,
                    maxImageSize: MAX_IMAGE_SIZE,
                    cMapUrl: CMAP_URL,
                    cMapPacked: CMAP_PACKED,
                })
                this.pdfLoadingTask = loadingTask

                // @ts-ignore
                loadingTask.onProgress = (progressData: any) => {
                    this.progress(progressData.loaded / progressData.total)
                }

                return loadingTask.promise.then(
                    (pdfDocument: any) => {
                        // Document loaded, specifying document for the viewer.
                        console.log(this)
                        this.pdfDocument = pdfDocument
                        this.pdfViewer.setDocument(pdfDocument)
                        this.pdfLinkService.setDocument(pdfDocument)
                        this.pdfHistory.initialize({ fingerprint: pdfDocument.fingerprint })

                        this.loadingBar.hide()
                        vueInstance.$loader.stop();
                        this.setTitleUsingMetadata(pdfDocument)
                    },
                    (exception: any) => {
                        const message = exception && exception.message
                        const l10n = this.l10n
                        const loadingErrorMessage = l10n.get('loading_error', null, 'An error occurred while loading the PDF.')

                        loadingErrorMessage.then((msg: any) => {
                            this.error(msg, { message })
                        })
                        this.loadingBar.hide()
                        vueInstance.$loader.stop();
                    }
                )
            },

            /**
             * Closes opened PDF document.
             * @returns {Promise} - Returns the promise, which is resolved when all
             *                      destruction is completed.
             */
            close() {
                const errorWrapper = document.getElementById('errorWrapper')
                if (!errorWrapper) return
                errorWrapper.hidden = true

                if (!this.pdfLoadingTask) {
                    return Promise.resolve()
                }

                const promise = this.pdfLoadingTask?.destroy()
                this.pdfLoadingTask = null

                if (this.pdfDocument) {
                    this.pdfDocument = null

                    this.pdfViewer.setDocument(null)
                    this.pdfLinkService.setDocument(null, null)

                    if (this.pdfHistory) {
                        this.pdfHistory.reset()
                    }
                }

                return promise
            },

            get loadingBar() {
                const bar = new pdfjsViewer.ProgressBar('#loadingBar', {})
                // @ts-ignore
                return pdfjsLib.shadow(this, 'loadingBar', bar)
            },

            setTitleUsingUrl: function pdfViewSetTitleUsingUrl(url: any) {
                this.url = url
                // @ts-ignore
                let title = pdfjsLib.getFilenameFromUrl(url) || url
                console.log(title)
                try {
                    title = decodeURIComponent(title)
                    console.log(title)
                } catch (e) {
                    // decodeURIComponent may throw URIError,
                    // fall back to using the unprocessed url in that case
                }
                this.setTitle(title)
            },

            setTitleUsingMetadata(pdfDocument: any) {
                pdfDocument.getMetadata().then((data: any) => {
                    const info = data.info,
                        metadata = data.metadata
                    this.documentInfo = info
                    this.metadata = metadata
                    console.log(data, info, metadata)
                    // Provides some basic debug information
                    console.log('PDF ' + pdfDocument.fingerprint + ' [' + info.PDFFormatVersion + ' ' + (info.Producer || '-').trim() + ' / ' + (info.Creator || '-').trim() + ']' + ' (PDF.js: ' + (pdfjsLib.version || '-') + ')')

                    let pdfTitle
                    if (metadata && metadata.has('dc:title')) {
                        const title = metadata.get('dc:title')
                        // Ghostscript sometimes returns 'Untitled', so prevent setting the
                        // title to 'Untitled.
                        if (title !== 'Untitled') {
                            pdfTitle = title
                        }
                    }

                    if (!pdfTitle && info && info.Title) {
                        pdfTitle = info.Title
                    }

                    if (pdfTitle) {
                        this.setTitle(pdfTitle + ' - ' + document.title)
                    }
                })
            },

            setTitle: function pdfViewSetTitle(title: string) {
                // document.title = title
                console.log(title)
                const titleEl = document.getElementById('title')
                if (titleEl) titleEl.textContent = title
            },

            error: function pdfViewError(message: string, moreInfo: any) {
                const l10n = this.l10n
                // @ts-ignore
                const moreInfoText = [l10n.get('error_version_info', { version: pdfjsLib.version || '?', build: pdfjsLib.build || '?' }, 'PDF.js v{{version}} (build: {{build}})')]
                if (moreInfo) {
                    moreInfoText.push(l10n.get('error_message', { message: moreInfo.message }, 'Message: {{message}}'))
                    if (moreInfo.stack) {
                        moreInfoText.push(l10n.get('error_stack', { stack: moreInfo.stack }, 'Stack: {{stack}}'))
                    } else {
                        if (moreInfo.filename) {
                            moreInfoText.push(l10n.get('error_file', { file: moreInfo.filename }, 'File: {{file}}'))
                        }
                        if (moreInfo.lineNumber) {
                            moreInfoText.push(l10n.get('error_line', { line: moreInfo.lineNumber }, 'Line: {{line}}'))
                        }
                    }
                }
                const errorWrapper = document.getElementById('errorWrapper')

                if (!errorWrapper) return
                errorWrapper.hidden = false
                const errorMessage = document.getElementById('errorMessage')

                if (!errorMessage) return
                errorMessage.textContent = message
                const closeButton = document.getElementById('errorClose')
                if (!closeButton) return
                closeButton.onclick = function () {
                    errorWrapper.hidden = true
                }
                const errorMoreInfo = document.getElementById('errorMoreInfo')
                if (!errorMoreInfo) return
                const moreInfoButton = document.getElementById('errorShowMore')
                if (!moreInfoButton) return
                const lessInfoButton = document.getElementById('errorShowLess')
                if (!lessInfoButton) return
                if (moreInfoButton)
                    moreInfoButton.onclick = function () {
                        errorMoreInfo.hidden = false
                        moreInfoButton.hidden = true
                        lessInfoButton.hidden = false
                        errorMoreInfo.style.height = errorMoreInfo.scrollHeight + 'px'
                    }
                if (lessInfoButton)
                    lessInfoButton.onclick = function () {
                        errorMoreInfo.hidden = true
                        moreInfoButton.hidden = false
                        lessInfoButton.hidden = true
                    }
                if (moreInfoButton) moreInfoButton.hidden = false
                if (lessInfoButton) lessInfoButton.hidden = true
                Promise.all(moreInfoText).then(function (parts) {
                    // @ts-ignore
                    errorMoreInfo.value = parts.join('\n')
                })
            },

            progress: function pdfViewProgress(level: number) {
                vueInstance.$loader.go();

                const percent = Math.round(level * 100)
                // Updating the bar if value increases.
                if (percent > this.loadingBar.percent || isNaN(percent)) {
                    this.loadingBar.percent = percent
                }
            },

            get pagesCount() {
                return this.pdfDocument.numPages
            },

            get page() {
                return this.pdfViewer.currentPageNumber
            },

            set page(val) {
                this.pdfViewer.currentPageNumber = val
            },

            zoomIn: function pdfViewZoomIn(ticks: number) {
                let newScale = this.pdfViewer.currentScale
                do {
                    newScale = (newScale * DEFAULT_SCALE_DELTA).toFixed(2)
                    newScale = Math.ceil(newScale * 10) / 10
                    newScale = Math.min(MAX_SCALE, newScale)
                } while (--ticks && newScale < MAX_SCALE)
                this.pdfViewer.currentScaleValue = newScale
            },

            zoomOut: function pdfViewZoomOut(ticks: number) {
                let newScale = this.pdfViewer.currentScale
                do {
                    newScale = (newScale / DEFAULT_SCALE_DELTA).toFixed(2)
                    newScale = Math.floor(newScale * 10) / 10
                    newScale = Math.max(MIN_SCALE, newScale)
                } while (--ticks && newScale > MIN_SCALE)
                this.pdfViewer.currentScaleValue = newScale
            },

            initUI: function pdfViewInitUI() {
                const eventBus = new pdfjsViewer.EventBus()
                this.eventBus = eventBus

                const linkService = new pdfjsViewer.PDFLinkService({
                    eventBus,
                })
                this.pdfLinkService = linkService

                this.l10n = pdfjsViewer.NullL10n

                const container = document.getElementById('viewerContainer')
                const pdfViewer = new pdfjsViewer.PDFViewer({
                    container,
                    eventBus,
                    linkService,
                    l10n: this.l10n,
                    useOnlyCssZoom: USE_ONLY_CSS_ZOOM,
                    textLayerMode: TEXT_LAYER_MODE,
                })
                console.log(pdfViewer)
                this.pdfViewer = pdfViewer
                linkService.setViewer(pdfViewer)

                this.pdfHistory = new pdfjsViewer.PDFHistory({
                    eventBus,
                    linkService,
                })
                linkService.setHistory(this.pdfHistory)

                document.getElementById('previous')?.addEventListener('click', function () {
                    PDFViewerApplication.page--
                })

                document.getElementById('next')?.addEventListener('click', function () {
                    PDFViewerApplication.page++
                })

                document.getElementById('zoomIn')?.addEventListener('click', function () {
                    // @ts-ignore
                    PDFViewerApplication.zoomIn()
                })

                document.getElementById('zoomOut')?.addEventListener('click', function () {
                    // @ts-ignore
                    PDFViewerApplication.zoomOut()
                })

                document.getElementById('pageNumber')?.addEventListener('click', function () {
                    // @ts-ignore
                    this.select()
                })

                document.getElementById('pageNumber')?.addEventListener('change', function (this: any) {
                    PDFViewerApplication.page = this.value | 0

                    // Ensure that the page number input displays the correct value,
                    // even if the value entered by the user was invalid
                    // (e.g. a floating point number).
                    if (this.value !== PDFViewerApplication.page.toString()) {
                        this.value = PDFViewerApplication.page
                    }
                })

                eventBus.on('pagesinit', function () {
                    // We can use pdfViewer now, e.g. let's change default scale.
                    pdfViewer.currentScaleValue = DEFAULT_SCALE_VALUE
                })

                eventBus.on(
                    'pagechanging',
                    function (evt: any) {
                        const page = evt.pageNumber
                        const numPages = PDFViewerApplication.pagesCount

                        // @ts-ignore
                        document.getElementById('pageNumber').value = page
                        // @ts-ignore
                        document.getElementById('previous').disabled = page <= 1
                        // @ts-ignore
                        document.getElementById('next').disabled = page >= numPages
                    },
                    true
                )
            },
        }

        document.addEventListener(
            'DOMContentLoaded',
            function () {
                console.log('PDFViewerApplication.initUI()')
            },
            true
        )

        // The offsetParent is not set until the PDF.js iframe or object is visible;
        // waiting for first animation.
        const animationStarted = new Promise(function (resolve) {
            window.requestAnimationFrame(resolve)
        })

        // We need to delay opening until all HTML is loaded.
        animationStarted.then(function () {
            PDFViewerApplication.initUI()
            // PDFViewerApplication.open({
            //     url: 'http://192.168.1.28:8182/api/file/301d5118-15b6-406e-8e62-18383860a0eb-e1dffe5c-d1fc-4f39-bdb2-3898c93b9967-c0e4db9e-8485-421b-83ab-ced2fbede047',
            // })
        })

        if (this.pdf)
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            PDFViewerApplication.close().then(() => {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                PDFViewerApplication.open({
                    url: this.$route.params.pdfUrl,
                })
                this.pdf = this.$route.params.pdfUrl
            })
        else {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            PDFViewerApplication.open({
                url: this.$route.params.pdfUrl,
            })
            this.pdf = this.$route.params.pdfUrl
        }
    },
})
